import api from '@/api/api.js'

export default {
    storeOperation(data) {
        const promise = api.comptabilite().post('/operations', data)
        return promise.then((response) => response.data)
    },

    storeReliquat(data) {
        const promise = api.comptabilite().post('/operations/reliquats', data)
        return promise.then((response) => response.data)
    },

    storeCompteOperation(idCompte, idOperation) {
        const promise = api.comptabilite().put('/comptes/' + idCompte + '/operations/' + idOperation)
        return promise.then((response) => response.data)
    },

    getOperationByDateUserCompte(date, idUser, idCompte) {
        const promise = api.comptabilite().get('/operation/' + date + '/' + +idUser + '/' + idCompte)
        return promise.then((response) => response.data)
    },

    getVersementsEnAttenteByCompte(idCompte) {
        const promise = api.comptabilite().get(`versements_en_attente/${idCompte}`)
        return promise.then((response) => response.data)
    },

    getAnOperation(idOp) {
        const promise = api.comptabilite().get('/operation/' + idOp)
        return promise.then((response) => response.data)
    },
    updateExistingOperation(data) {
        const promise = api.comptabilite().post('/operation/update', data)
        return promise.then((response) => response.data)
    },

    getTotauxByDateUserCompte(date, idUser, idCompte) {
        const promise = api.comptabilite().get('/totauxParDate/' + date + '/' + idUser + '/' + idCompte)
        return promise.then((response) => response.data)
    },

    getLignesDepensesByIdOp(idOp) {
        const promise = api.comptabilite().get('/lignesSortieCaisse/' + idOp)
        return promise.then((response) => response.data)
    },
    confirmVersementReception(idOp) {
        const promise = api.comptabilite().get(`/versement_confirm/update/${idOp}`)
        return promise.then((response) => response.data)
    },
    getCarnetsDetailsPerOperation(idOp) {
        const promise = api.comptabilite().get(`carnets_details/${idOp}`)
        return promise.then((response) => response.data)
    },

    storePaiementDette(data) {
        const promise = api.comptabilite().post('/caisse/paiement_dette', data)
        return promise.then((response) => response.data)
    },

    getJournalCaisse(data) {
        const promise = api.comptabilite().post('/operations/journal-caisse', data)
        return promise.then((response) => response.data)
    },

    saveProvision(data) {
        const promise = api.comptabilite().post('/tresorerie/approvisioner', data)
        return promise.then((response) => response.data)
    },

    getJournalTresorier(data) {
        const promise = api.comptabilite().post('/tresorerie/journal-tresorerie', data)
        return promise.then((response) => response.data)
    },

    getSoldeTresorier(compte_id) {
        const promise = api.comptabilite().get('/operations/compte/'+compte_id+'/solde-disponible')
        return promise.then((response) => response.data)
    },

    getSoldeCourantLigneBudgetaire(data) {
        const promise = api.comptabilite().post('/ligne-budgetaire/solde-restant', data)
        return promise.then((response) => response.data)
    },

    getListeReliquats(data) {
        const promise = api.comptabilite().post('/reliquats/liste', data)
        return promise.then((response) => response.data)
    },

    reglerReliquat(data) {
        const promise = api.comptabilite().post('/reliquats/regler', data)
        return promise.then((response) => response.data)
    },

    getSoldeDisponible(data) {
        const promise = api.comptabilite().post('/caisse-operations/solde-disponible', data)
        return promise.then((response) => response.data)
    },

    getSoldeDuJour(data) {
        const promise = api.comptabilite().post('/caisse-operations/solde-du-jour', data)
        return promise.then((response) => response.data)
    },

    getSoldeCourantCompteDepot(data) {
        const promise = api.comptabilite().post('/caisse-operations/solde-compte-depot', data)
        return promise.then((response) => response.data)
    },

    storeOperationCaisse(data) {
        const promise = api.comptabilite().post('/caisse-operations/store', data)
        return promise.then((response) => response.data)
    },

    updateOperationCaisse(data) {
        const promise = api.comptabilite().post('/caisse-operations/regler-paiement', data)
        return promise.then((response) => response.data)
    },

    getOperationsCaisse(data) {
        const promise = api.comptabilite().post('/caisse-operations/ligne-operations/'+data.page, data)
        return promise.then((response) => response.data)
    },

    confirmerVersement(data) {
        const promise = api.comptabilite().post('/caisse-operations/confirm-versement', data)
        return promise.then((response) => response.data)
    },

    storeLigneSortieDeCaisse(data) {
        const promise = api.comptabilite().post('/caisse-operations/store-depense', data)
        return promise.then((response) => response.data)
    },

    getSoldeCourantCompteDepense(data) {
        const promise = api.comptabilite().post('/caisse-operations/solde-compte-depense', data)
        return promise.then((response) => response.data)
    },

    storeDemandeAnnulation(data) {
        const promise = api.comptabilite().post('/demandes-annulations/store', data)
        return promise.then((response) => response.data)
    },

    getListeDemandeAnnulation(data) {
        const promise = api.comptabilite().post('/demandes-annulations/liste-operations', data)
        return promise.then((response) => response.data)
    },

    validerDemandeAnnulation(data) {
        const promise = api.comptabilite().post('/demandes-annulations/valider-annulation', data)
        return promise.then((response) => response.data)
    },

    getListeCoupons(data) {
        const promise = api.comptabilite().post('/caisse-operations/liste-coupons', data)
        return promise.then((response) => response.data)
    },

    getListeProduitsCreances(data) {
        const promise = api.comptabilite().post('/caisse-operations/produits-creances', data)
        return promise.then((response) => response.data)
    },

    getListeChargesExploitation(data) {
        const promise = api.comptabilite().post('/caisse-operations/charges-exploitation', data)
        return promise.then((response) => response.data)
    },

    getListeOperationsPatient(data) {
        const promise = api.comptabilite().post('/caisse-operations/operations-patient', data)
        return promise.then((response) => response.data)
    },

    generateBill(data) {
        const promise = api.comptabilite().post('/factures/generer-facture', data)
        return promise.then((response) => response.data)
    },

    standardizeInvoice(data) {
        const promise = api.comptabilite().post('/factures/normaliser-facture', data)
        return promise.then((response) => response.data)
    },

    getListeFacture(data) {
        const promise = api.comptabilite().post('/factures/show', data)
        return promise.then((response) => response.data)
    },

    getRemboursementAssurance(data) {
        const promise = api.comptabilite().post('/remboursement-assurances/liste-operations', data)
        return promise.then(response => response.data)
    },

    generateInsuranceBill(data) {
        const promise = api.comptabilite().post('/remboursement-assurances/generer-facture', data)
        return promise.then((response) => response.data)
    },

    getListeFactureAssurance(data) {
        const promise = api.comptabilite().post('/remboursement-assurances/factures', data)
        return promise.then((response) => response.data)
    },

    getOpertaionsEnAttente(data) {
        const promise = api.comptabilite().post('/caisse-operations/operation-en-attente', data)
        return promise.then((response) => response.data)
    },

    getListeTicketCaisse(data) {
        const promise = api.comptabilite().post('/factures/ticket-caisse', data)
        return promise.then((response) => response.data)
    },

    countDiscount(data) {
        const promise = api.comptabilite().post('/caisse-operations/compte-coupons', data)
        return promise.then((response) => response.data)
    },

    updateViewedDiscount(data) {
        const promise = api.comptabilite().post('/caisse-operations/coupon/valider-vue', data)
        return promise.then((response) => response.data)
    },

    countCancellationRequest() {
        const promise = api.comptabilite().get('/demandes-annulations/demande-attente')
        return promise.then((response) => response.data)
    },

    getBonConsultationFacture(data) {
        const promise = api.comptabilite().post('/factures/bon-consultation', data)
        return promise.then((response) => response.data)
    },

    saveVentePrestation(data) {
        const promise = api.comptabilite().post('/ligne-operations/vente-caisse/store', data)
        return promise.then((response) => response.data)
    },

    deleteVentePrestation(data) {
        const promise = api.comptabilite().post('/ligne-operations/delete', data)
        return promise.then((response) => response.data)
    },

    saveProforma(data) {
        const promise = api.comptabilite().post('/facture-proforma/store', data)
        return promise.then((response) => response.data)
    },

    updateOperationAttente(data) {
        const promise = api.comptabilite().post('/ligne-operations/update', data)
        return promise.then((response) => response.data)
    },

    cancelInvoice(data) {
        const promise = api.comptabilite().post('/factures/cancel', data)
        return promise.then((response) => response.data)
    },

    cancelPayBackInvoice(data) {
        const promise = api.comptabilite().post('/remboursement-assurances/cancel', data)
        return promise.then((response) => response.data)
    },
}